import { getAuth, onAuthStateChanged, User } from 'firebase/auth';

let currentUser: User | null = null;
const connectedGoogleEmailKey = 'sonoma.googleDocs.email';

export function initAuth(
  onSignedIn: () => void,
  onSignedOut: () => void
): () => void {
  const auth = getAuth();
  return onAuthStateChanged(auth, (user) => {
    currentUser = user;
    if (user) onSignedIn();
    else {
      onSignedOut();
      clearCachedGoogleAccessToken();
    }
  });
}

export function getCurrentUser(): User | null {
  return currentUser;
}

export function getCachedGoogleAccessToken(): string | null {
  const token = sessionStorage.getItem('sonoma.googleDocs.token');
  const expiresAt = sessionStorage.getItem('sonoma.googleDocs.expiresAt');
  if (token && expiresAt && Date.now() < parseInt(expiresAt, 10)) {
    return token;
  }
  return null;
}

export function setCachedGoogleAccessToken(token: string, expiresInMs: number): void {
  sessionStorage.setItem('sonoma.googleDocs.token', token);
  sessionStorage.setItem('sonoma.googleDocs.expiresAt', (Date.now() + expiresInMs).toString());
}

export function clearCachedGoogleAccessToken(): void {
  sessionStorage.removeItem('sonoma.googleDocs.token');
  sessionStorage.removeItem('sonoma.googleDocs.expiresAt');
  localStorage.removeItem(connectedGoogleEmailKey);
}

export function getCachedGoogleEmail(): string | null {
  return localStorage.getItem(connectedGoogleEmailKey);
}

export function setCachedGoogleEmail(email: string): void {
  localStorage.setItem(connectedGoogleEmailKey, email);
}

export async function googleSignIn(): Promise<void> {
  const { signInWithPopup, GoogleAuthProvider } = await import('firebase/auth');
  const auth = getAuth();

  if (auth.currentUser) return;

  const provider = new GoogleAuthProvider();
  provider.addScope('https://www.googleapis.com/auth/documents');
  provider.addScope('https://www.googleapis.com/auth/drive.file');
  await signInWithPopup(auth, provider);
}
